import styles from 'partials/page-frame.module.scss';

export const PageFrame = ({ children }) => {
	return (
		<main className={styles.wrapper}>
			{children}
		</main>
	);
};
